// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buttons-group-collection[data-v-2e314af8]{\n    display: grid;\n    grid-template-columns: auto auto auto;\n}\n", ""]);
// Exports
module.exports = exports;
